import IconButton from '@planday-corp/ui/actions/IconButton';
import Drawer from '@planday-corp/ui/overlays/drawers/Drawer';
import {grey10} from '@planday-corp/ui/styles/colors';
import Text from '@planday-corp/ui/text/Text';
import React, {ReactNode, useState} from 'react';
import {Link} from 'react-router-dom';
import styled from 'styled-components';

const StyledMenu = styled.ul`
  list-style: none;
  margin: -1rem 0;
  padding: 0;
`;

const StyledIconButton = styled(IconButton)`
  position: absolute;
  right: 0.25rem;
  top: 0.25rem;
  z-index: 201;

  > svg {
    fill: black;
  }
`;

const StyledLink = styled(Link)`
  padding: 1rem 1.5rem;
  margin: 0 -1rem;
  display: block;
  text-decoration: none;
  outline: none;
  cursor: pointer;
  background: transparent;

  &:hover {
    background: ${grey10};
  }
`;

export interface DevApp {
  title: string;
  appName: string;
  path: string;
  queryString?: string;
  component: ReactNode;
}

export default function DevMenu({apps}: {apps: DevApp[]}) {
  const [showMenu, setShowMenu] = useState<boolean>(false);

  const handleToggleMenu = () => {
    setShowMenu(!showMenu);
  };

  return (
    <>
      <StyledIconButton
        key={`toggleIcon-`}
        iconName={'burger'}
        onClick={handleToggleMenu}
        title={'toggle'}
      />
      {showMenu && (
        <Drawer title={'DEV MENU'} onClose={() => setShowMenu(false)}>
          <StyledMenu>
            {apps.map(app => (
              <li key={app.appName}>
                <StyledLink
                  to={`${app.path}${app?.queryString || ''}`}
                  key={app.appName}
                  title={app.appName}
                >
                  <Text value={app.title} size="label" />
                </StyledLink>
              </li>
            ))}
          </StyledMenu>
        </Drawer>
      )}
    </>
  );
}
